import { gql, useMutation } from '@apollo/client'
import {
  MutationAnnouncementEditArgs,
  MutationAnnouncementEditPayload,
} from 'src/generated'

const MUTATION_ANNOUNCEMENT_EDIT = gql`
  mutation AnnouncementEdit($input: MutationAnnouncementEditInput!) {
    announcementEdit(input: $input) {
      announcement {
        id
      }
    }
  }
`

const useAnnouncementEditMutation = () => {
  return useMutation<
    { announcementEdit: MutationAnnouncementEditPayload },
    MutationAnnouncementEditArgs
  >(MUTATION_ANNOUNCEMENT_EDIT)
}

export default useAnnouncementEditMutation
